// extracted by mini-css-extract-plugin
export default {"entity":"lsf-entity","entity__info":"lsf-entity__info","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630377018
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  